import ApiService from "./ApiService";
import { CriteriaEntityGetResponse, CriteriaEntityPagedResponse, CriteriaEntityPostRequest, CriteriaEntityPostResponse, CriteriaEntityPutRequest, CriteriaEntityPutResponse } from "src/entities/CriteriaEntity";

export const criteriaQueryKeys = {
	list: ["criteria"] as const,
	get: (id: string) => ["criteria", id] as const,
};

export default class CriteriaService extends ApiService {
	public async getCriteria() {
		return await this.request.get<CriteriaEntityPagedResponse>(`/api/v1/criteria`, { params: { Page: 1, PageSize: 100 } });
	}
	public async get(id: number) {
		return await this.request.get<CriteriaEntityGetResponse>(`/api/v1/criteria/${id}`);
	}
	public async post(data: CriteriaEntityPostRequest) {
		return await this.request.post<CriteriaEntityPostResponse>(`/api/v1/criteria`, data);
	}
	public async put(id: number, data: CriteriaEntityPutRequest) {
		return await this.request.put<CriteriaEntityPutResponse>(`/api/v1/criteria/${id}`, data);
	}
	public async delete(id: number) {
		return await this.request.delete(`/api/v1/criteria/${id}`);
	}
}
